import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { resources } from './langs';
import { defaultNS, fallbackLng, supportedLngs, languageStorageKey } from './locales-config';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS,
    fallbackLng,
    load: 'languageOnly',
    fallbackNS: defaultNS,
    nonExplicitSupportedLngs: true,
    supportedLngs: [...supportedLngs],
    interpolation: { escapeValue: false },
    detection: {
      caches: ['localStorage'],
      lookupLocalStorage: languageStorageKey,
      order: ['localStorage', 'navigator', 'htmlTag'],
    },
  });
